export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '20px',
  },
  input: {
    height: '35px',
    width: '100%',
    border: '1px solid rgb(204, 204, 204)',
    padding: '5px 10px',
    boxShadow: 'rgb(211, 211, 211) 0px 0px 2px inset',
    transitionDuration: '.3s',
    transitionProperty: 'box-shadow',
  },
  svg: {
    width: 20,
    height: 20,
    marginRight: '10px',
  },
  terms: {
    maxHeight: '350px',
    display: 'flex',
    overflowY: 'scroll',
    width: '100%',
    padding: '5px 10px',
    boxSizing: 'border-box',
    backgroundColor: 'white',
    boxShadow: 'inset .5px .5px 4px .5px rgba(0,0,0,0.17)',
    flexDirection: 'column',
  },
  term: {
    margin: '5px 2px',
    cursor: 'pointer',
    fontSize: '12.5px',
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
    alignItems: 'center',
  },
};
